export const LIGHT_DESIRE_MIN = 0.05;
